import { useScrollReveal } from "../hooks/useScrollReveal";

const InspirationBanner = () => {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className="relative py-16 md:py-24 bg-[var(--bg-primary)] overflow-hidden"
    >
      {/* Background Orbs */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-orange-400/5 rounded-full blur-3xl" />

      <div
        className={`max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Decorative Quote Icon */}
        <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-xl md:rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/20 dark:to-orange-900/10 mb-5 sm:mb-6 md:mb-8 shadow-lg shadow-orange-500/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-500"
          >
            <path d="M9.375 3a1.875 1.875 0 000 3.75h1.875v4.5H3.375A1.875 1.875 0 011.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 019.375 3zM12.75 12a2.25 2.25 0 00-2.25 2.25c0 1.268.68 2.386 1.702 2.998.768.456 1.65.752 2.548.752h2.007a2.25 2.25 0 002.25-2.25c0-1.268-.68-2.386-1.702-2.998a3.753 3.753 0 00-2.548-.752H15.75z" />
            <path d="M9.375 21a1.875 1.875 0 000-3.75h1.875v-4.5H3.375A1.875 1.875 0 011.5 10.875v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 019.375 21zm9.375 0a1.875 1.875 0 000-3.75h1.875v-4.5h-7.875A1.875 1.875 0 0110.875 10.875v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0118.75 12z" />
          </svg>
        </div>

        {/* Quote Text */}
        <blockquote className="relative">
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-[var(--text-secondary)] leading-relaxed md:leading-relaxed font-light italic">
            "Did you ever imagine seeing a shooter from Nagpur compete on the
            national stage? We didn't. Did you expect young marksmen from our
            city to excel in air pistol and air rifle shooting? Nor did we. That
            was until we got to work — honing raw talent, instilling precision,
            and proving that champions are made right here at{" "}
            <span className="font-semibold text-orange-500 not-italic">
              Orange City Sport Shooting Club
            </span>
            ."
          </p>
        </blockquote>

        {/* Attribution */}
        <div className="mt-8 flex flex-col items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white font-bold text-sm">
              AP
            </div>
            <div className="text-left">
              <div className="font-semibold text-[var(--text-primary)] text-sm">
                Coach Anil Pande
              </div>
              <div className="text-xs text-[var(--text-tertiary)]">
                Head Coach, OCSSC
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-orange-300 dark:to-orange-700" />
            <div className="w-2 h-2 rounded-full bg-orange-400" />
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-orange-300 dark:to-orange-700" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InspirationBanner;
